module.exports = __webpack_public_path__ + "assets/images/statue-04.b5b9e8f59a9acab0a78718f7f776e1a4.svg";